<!-- @format -->

<template>
    <h5 class="gst-event-package-offer-not-available__title">
        {{ $t('title') }}
    </h5>
</template>

<script>
export default {
    name: 'EventStateInactiveWarning',
    i18nOptions: {
        namespaces: '_common',
        keyPrefix: 'messages.eventState.inactive',
    },
};
</script>
